import dayjs from 'dayjs'
const formatDate = value => {
  if (value) {
    return dayjs(String(value)).format('DD MMM YYYY')
  }
}

const formatDateTime = value => {
  if (value) {
    return dayjs(String(value)).format('DD MMM YYYY - HH:mm')
  }
}

export { formatDate, formatDateTime }
